import React from "react";

export default function SectionHeader({ overline, title, description, right, testid }) {
  return (
    <div
      className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 pb-5 border-b border-slate-800/80 mb-6"
      data-testid={testid}
    >
      <div>
        {overline ? (
          <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-cyan-400 mb-2 flex items-center gap-2">
            <span className="inline-block h-1 w-6 bg-cyan-500" />
            {overline}
          </div>
        ) : null}
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-50 tracking-tight">
          {title}
        </h1>
        {description ? (
          <p className="text-sm text-slate-400 mt-2 max-w-2xl">{description}</p>
        ) : null}
      </div>
      {right ? <div>{right}</div> : null}
    </div>
  );
}
